// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Create_wrapper__1tWVn","footer":"Create_footer__12VV4","mixtureDetails":"Create_mixtureDetails__2gnTz","result":"Create_result__30a0-","main":"Create_main__2btXP"};